import { render, staticRenderFns } from "./InvestmentStrategy.vue?vue&type=template&id=86bc1b9e&scoped=true"
import script from "./InvestmentStrategy.vue?vue&type=script&lang=js"
export * from "./InvestmentStrategy.vue?vue&type=script&lang=js"
import style0 from "./InvestmentStrategy.vue?vue&type=style&index=0&id=86bc1b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bc1b9e",
  null
  
)

export default component.exports